import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductRelatedPartsActions } from './product-related-parts.actions';
import { DpProductsApiService } from '@app-modules/product/shared/services/products-api.service';

export const loadRelatedPartsConfigEffect = createEffect(
  (actions$ = inject(Actions), productsApiService = inject(DpProductsApiService)) =>
    actions$.pipe(
      ofType(ProductRelatedPartsActions.loadConfig),
      switchMap(({ code }) =>
        productsApiService
          .getRelatedPartsConfig(code)
          .pipe(map(({ relatedParts = [] }) => ProductRelatedPartsActions.loadConfigSuccess({ relatedParts })))
      )
    ),
  { functional: true }
);
